import React, { useEffect, useRef, useState } from "react";
import ProductCardSpecial from "./ProductCardSpecial";
import Loading from "./Loading";
import { httpReauest } from "../../utils/httpRequest";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Countdown from "react-countdown";

const DiscountedProduct = ({ full }) => {
  const [loading, setLoading] = useState();
  const [data, setdata] = useState();
  const [vehcledata, setvehcledata] = useState();
  const [hour, sethours] = useState();
  const [compelete, setcompelete] = useState();

  useEffect(() => {
    getData();
  }, []);

  async function getData(params) {
    setLoading(true);
    await httpReauest("GET", "/vehicle/timer", {}, {}).then(({ data }) => {
      setvehcledata(data?.data?.vehicles);
      sethours(data?.data?.hour);
    });
    setLoading(false);
  }
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  const renderer = ({ hours, minutes, seconds, completed, days }) => {
    if (completed) {
      setcompelete(true);
      return (
        <span className=" text-[#F42A1C] flex gap-2 font-[700]">
          {days}:{hours}:{minutes}:{seconds}
          <img src="/time.png" alt="timeer" />
        </span>
      );
    } else {
      setcompelete(false);
      return (
        <span className=" text-[#F42A1C] flex gap-2 font-[700]">
          {days}:{hours}:{minutes}:{seconds}
          <img src="/time.png" alt="timeer" />
        </span>
      );
    }
  };

  if (compelete) {
    return null;
  }

  return (
    <div className={` w-full  relative `}>
      <div className="flex justify-between items-center">
        <h2 className=" text-[24px] font-[700] text-[#F42A1C]">زیر قیمت</h2>
        {hour && <Countdown date={new Date(hour)} renderer={renderer} />}
      </div>
      <div
        ref={navigationPrevRef}
        className=" -right-[8px] bg-[#FAA719] z-10 w-[35px] h-[35px] absolute top-[54%] translate-y-[-50%] rounded-full flex justify-center items-center"
      >
        <FaAngleRight />
      </div>
      <div
        ref={navigationNextRef}
        className="-left-[8px] bg-[#FAA719] z-50 w-[35px] h-[35px] absolute top-[54%] translate-y-[-50%] rounded-full flex justify-center items-center"
      >
        <FaAngleLeft />
      </div>
      <div className={` w-full px-2`}>
        <Swiper
          slidesPerView={4}
          spaceBetween={14}
          modules={[Pagination, Navigation]}
          pagination={{ clickable: true }}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
          }}
          className="mySipe"
        >
          {loading ? (
            <Loading />
          ) : (
            vehcledata?.map((e) => (
              <>
                <SwiperSlide>
                  {" "}
                  <span className="relative">
                    <ProductCardSpecial compelete={compelete} data={e} />
                  </span>
                </SwiperSlide>
              </>
            ))
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default DiscountedProduct;
